module.exports = __webpack_public_path__ + "img/busfull-alert-red.54fed2d5.svg";